import React, { useState } from "react";
import PartnerHeader from "../../component/PartnerHeader";
import PartnerFooter from "../../component/PartnerFooter";

function JobAlerts() {
  const [alerts, setAlerts] = useState([
    {
      id: 1,
      title: "Java DSA Trainer Available",
      technology: "Java DSA",
      location: "Noida",
      date: "22 Aug 2026",
      active: true,
    },
    {
      id: 2,
      title: "AWS Solution Architect Trainer",
      technology: "AWS",
      location: "Karnataka",
      date: "22 Aug 2026",
      active: true,
    },
    {
      id: 3,
      title: "Python Full Stack Trainer",
      technology: "Python",
      location: "Delhi",
      date: "21 Aug 2026",
      active: false,
    },
  ]);

  const toggleAlert = (id) => {
    setAlerts((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, active: !item.active }
          : item
      )
    );
  };

  return (
    <>
  <PartnerHeader/>
    <div className="page">
      <div className="header">
        <div>
          <h1>Job Alerts</h1>
          <p>
            Jobs matching your preferred requirements.
          </p>
        </div>

        <button className="create">
          Create Alert
        </button>
      </div>

      <div className="alert-list">
        {alerts.map((alert) => (
          <div className="alert-card" key={alert.id}>
            <div className="alert-icon">
              🔔
            </div>

            <div className="alert-content">
              <h3>{alert.title}</h3>

              <p>
                {alert.technology} • {alert.location}
              </p>

              <small>
                Posted: {alert.date}
              </small>
            </div>

            <div className="alert-action">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={alert.active}
                  onChange={() =>
                    toggleAlert(alert.id)
                  }
                />
                <span></span>
              </label>

              <small>
                {alert.active
                  ? "Active"
                  : "Inactive"}
              </small>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .page {
          padding:30px;
          background:#f8fafc;
          min-height:100vh;
        }

        .header {
          display:flex;
          align-items:center;
          justify-content:space-between;
        }

        h1 {
          margin:0;
        }

        .header p {
          color:#64748b;
        }

        .create {
          border:0;
          background:#2563eb;
          color:white;
          padding:11px 18px;
          border-radius:7px;
          cursor:pointer;
        }

        .alert-list {
          margin-top:25px;
          max-width:900px;
        }

        .alert-card {
          display:flex;
          align-items:center;
          gap:15px;
          background:white;
          padding:20px;
          margin-bottom:12px;
          border-radius:12px;
          box-shadow:0 4px 15px rgba(0,0,0,.05);
        }

        .alert-icon {
          width:45px;
          height:45px;
          border-radius:50%;
          background:#dbeafe;
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .alert-content {
          flex:1;
        }

        .alert-content h3 {
          margin:0 0 5px;
        }

        .alert-content p {
          margin:0 0 5px;
          color:#475569;
        }

        .alert-content small {
          color:#94a3b8;
        }

        .alert-action {
          text-align:center;
        }

        .alert-action small {
          display:block;
          margin-top:5px;
          color:#64748b;
        }

        .switch {
          position:relative;
          display:inline-block;
          width:44px;
          height:24px;
        }

        .switch input {
          opacity:0;
          width:0;
          height:0;
        }

        .switch span {
          position:absolute;
          inset:0;
          background:#cbd5e1;
          border-radius:20px;
          cursor:pointer;
        }

        .switch span:before {
          content:"";
          position:absolute;
          width:18px;
          height:18px;
          left:3px;
          top:3px;
          background:white;
          border-radius:50%;
          transition:.2s;
        }

        .switch input:checked + span {
          background:#2563eb;
        }

        .switch input:checked + span:before {
          transform:translateX(20px);
        }

        @media(max-width:600px) {
          .header {
            align-items:flex-start;
            gap:15px;
            flex-direction:column;
          }

          .alert-card {
            align-items:flex-start;
          }
        }
      `}</style>
    </div>
    <PartnerFooter/>
    </>
  );
}

export default JobAlerts;